require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-o-o-puu.json") })
        }
      }, "path---photos-professional-o-o-puu");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-o-o-puu!./.cache/json/photos-professional-o-o-puu.json
// module id = 857
// module chunks = 231608221292675